import { appConstantSettings } from 'srcReact/appConstantSettings'
import { getCurrentApiDomain } from './organizationHelper'
import { isUserAuthorized } from './userHelper'
import { IKCore } from 'imagekitio-react'

export const downloadMedia = (isOriginal, hrefData, fileName) => {
  if (isOriginal === 1 && hrefData && hrefData.includes('http')) {
    fetch(hrefData)
      .then((response) => {
        return response.blob()
      })
      .then((blob) => {
        let url = window.URL.createObjectURL(new Blob([blob]))
        download(url, fileName)
      })
  } else {
    download(hrefData, fileName)
  }
}

export const download = (hrefData, fileName) => {
  let a = document.createElement('a')
  a.setAttribute('href', hrefData)
  a.setAttribute('download', fileName)
  a.setAttribute('target', '_blank')
  document.body.appendChild(a)
  a.click()
  a.parentNode.removeChild(a)
}

export const openMedia = (isOriginal, hrefData, fileName) => {
  if (isOriginal === 1 && hrefData && hrefData.includes('http')) {
    window.open(hrefData, '_blank', 'noopener,noreferrer')
  }
  //currently we are disabling open pdf preview for encrypted files, because browser has issue to process pdf files(base64) with large sizes
  else {
    const win = window.open('about:blank', '_blank')
    let html = ''
    html += '<html>'
    html += '<body style="margin:0!important">'
    html += `<embed width="100%" height="100%" src=${hrefData} type="application/pdf" />`
    html += '</body>'
    html += '</html>'
    setTimeout(() => {
      win.document.write(html)
    }, 0)
  }
}

export const convertByteToMB = (bytes) => {
  const megabytes = bytes / (1000 * 1000)
  return megabytes
}

const getIKObject = () => {
  const imagekit = new IKCore({
    publicKey: config.imageKitPublicKey,
    urlEndpoint: `https://ik.imagekit.io/${config.imageKitId}`,
    authenticationEndpoint: `${config.apiUrl}/v2/files/ik-auth/0`
  })
  return imagekit
}

export function isFileImage(file) {
  if (file) {
    let type = ''
    if (file.mime_type) {
      type = file.mime_type
    } else if (file['type']) {
      type = file['type']
    }
    return type && type.split('/')[0] === 'image'
  }
  return false
}

export const getCompressedImages = async (files, tag) => {
  const imagekit = getIKObject()
  //Create an array of upload promises
  const uploadPromises = files.map((file, index) =>
    imagekit.upload({
      file: file,
      fileName: file.name,
      tags: `${tag}-${index + 1}`
      // transformation: [
      //   {
      //     progressive: true
      //   }
      // ]
    })
  )
  return Promise.all(uploadPromises)
}

export const separateFilesByType = (files) => {
  const images = []
  const docs = []
  for (let i = 0; i < files.length; i++) {
    const file = files[i]
    if (isFileImage(file)) {
      images.push(file)
    } else {
      docs.push(file)
    }
  }
  return [images, docs]
}

export const proceesImagesWithIK = async (images, tag) => {
  let optimizedImages = []
  if (images.length > 0) {
    if (appConstantSettings.ENABLE_COMPRESSION) {
      optimizedImages = await getCompressedImages(images, tag)
    } else {
      optimizedImages = images
    }
  }
  return optimizedImages
}

export const getProcessFiles = async (files) => {
  const images = []
  const docs = []
  let optimizedImages = []
  for (let i = 0; i < files.length; i++) {
    const file = files[i]
    if (isFileImage(file)) {
      images.push(file)
    } else {
      docs.push(file)
    }
  }
  if (images.length > 0) {
    if (appConstantSettings.ENABLE_COMPRESSION) {
      optimizedImages = await getCompressedImages(images)
    } else {
      optimizedImages = images
    }
  }
  return [...optimizedImages, ...docs]
}

export const isValidFilesCount = (files, filesLimit = appConstantSettings.FILES_LIMIT) => {
  if (files.length > filesLimit) {
    return false
  }
  return true
}

export const validateFiles = (files, allowImages, allowDocs) => {
  if (!isValidFilesCount(files)) {
    // setErrorMessage(t('messenger.clientErrors.fileCountError', { filesLimit: filesLimit }))
    return 'FILE_COUNT_ERROR'
  }
  const allowedImageTypes = appConstantSettings.ACCEPTED_IMAGE_TYPES
  const allowedDocumentTypes = appConstantSettings.ACCEPTED_DOCUMENT_TYPES
  const allowedImageSizeInMB = appConstantSettings.MAX_IMAGE_SIZE_MB
  const allowedDocumentSizeInMB = appConstantSettings.MAX_DOC_SIZE_MB

  const allowedImageTypesArray =
    allowedImageTypes.length > 0 ? allowedImageTypes.split(',').map((item) => item.trim()) : []
  const allowedDocumentTypesArray =
    allowedDocumentTypes.length > 0 ? allowedDocumentTypes.split(',').map((item) => item.trim()) : []

  for (let i = 0; i < files.length; i++) {
    const extension = files[i].name.split('.').pop().toLowerCase()

    const fileSizeInMB = files[i].size / 1024 / 1024 // in MiB
    if (
      (allowImages &&
        allowDocs &&
        !allowedImageTypesArray.includes(extension) &&
        !allowedDocumentTypesArray.includes(extension)) ||
      (allowImages && !allowDocs && !allowedImageTypesArray.includes(extension)) ||
      (allowDocs && !allowImages && !allowedDocumentTypesArray.includes(extension))
    ) {
      //setErrorMessage(t('messenger.clientErrors.fileExtError'))
      return 'FILE_TYPE_ERROR'
    }

    if (allowImages && allowedImageTypesArray.includes(extension) && fileSizeInMB > allowedImageSizeInMB) {
      // setErrorMessage(
      //   t('messenger.clientErrors.imageFileSizeError', { imageFileSize: messengerSettings.MAX_IMAGE_SIZE_MB })
      // )
      return 'IMG_SIZE_ERROR'
    }
    if (allowDocs && allowedDocumentTypesArray.includes(extension) && fileSizeInMB > allowedDocumentSizeInMB) {
      // setErrorMessage(
      //   t('messenger.clientErrors.docFileSizeError', { docFileSize: messengerSettings.MAX_DOC_SIZE_MB })
      // )
      return 'DOC_SIZE_ERROR'
    }
  }
  return ''
}

export async function createFileFromUrl(url, fileName, fileType) {
  let response = await fetch(url)
  let data = await response.blob()
  let metadata = {
    type: fileType
  }
  let file = new File([data], fileName, metadata)
  return file
}
